import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "src/i18n";


interface OpenDeleteModalProps {
  title?: string;
  text?: string;
  textNode?: React.ReactNode;
  confirmText?: string;
  onConfirm: () => void;
}

export const openDeleteModal = ({
  title = i18n.t("are-you-sure"),
  text = i18n.t("delete-record-message"),
  textNode,
  confirmText = i18n.t("delete-record"),
  onConfirm,
}: OpenDeleteModalProps) => {
  return modals.openConfirmModal({
    title: <Text fw={500}>{title}</Text>,
    centered: true,
    children: (
      <>
        <Text size="sm" lh={1.2}>
          {textNode ? "" : text}
        </Text>
        {textNode}
      </>
    ),
    labels: { confirm: confirmText, cancel: i18n.t("cancel") },
    groupProps: { gap: "xs", mt: "lg" },
    confirmProps: { color: "red" },
    onCancel: () => {
      // Do something here...
      return;
    },
    onConfirm: () => onConfirm(),
    styles: { body: { minHeight: "auto" } },
  });
};
